import * as React from 'react';

const CloseIcon = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={24} height={24} rx={12} fill="#F1ECF8" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M7.19102 7.19114C7.44571 6.93645 7.85864 6.93645 8.11333 7.19114L12 11.0778L15.8867 7.19114C16.1414 6.93645 16.5543 6.93645 16.809 7.19114C17.0637 7.44583 17.0637 7.85876 16.809 8.11345L12.9223 12.0001L16.809 15.8868C17.0637 16.1415 17.0637 16.5544 16.809 16.8091C16.5543 17.0638 16.1414 17.0638 15.8867 16.8091L12 12.9224L8.11333 16.8091C7.85864 17.0638 7.44571 17.0638 7.19102 16.8091C6.93633 16.5544 6.93633 16.1415 7.19102 15.8868L11.0777 12.0001L7.19102 8.11345C6.93633 7.85876 6.93633 7.44583 7.19102 7.19114Z"
      fill="#6B3EB4"
    />
  </svg>
);
export default CloseIcon;
